import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_21.module.css";
import Head from "next/head";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter22.json";


export default function Chapter_22() {
  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
      <Head>
        <title>BRAIN CHANGE EVOLUTION | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content=" Divine Infinite Being, Central Doctrine, Chapter-XXI"
        ></meta>
        <meta
          property="og:title"
          content="BRAIN CHANGE EVOLUTION | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta property="og:image:alt" content="Illustration depicting the evolution of brain change within a divine framework, featuring cosmic patterns and neural transformations."></meta>
        <meta
          property="og:description"
          content="Explore the central doctrine of brain change evolution within the framework of the Divine Infinite Being, blending divine insights with the latest in cognitive development and neural transformation."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=22"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"></meta>
        <meta property="twitter:image:alt" content="Illustration depicting the evolution of brain change within a divine framework, featuring cosmic patterns and neural transformations."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=22"></meta>
        <meta name="twitter:title" content="BRAIN CHANGE EVOLUTION | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Explore the central doctrine of brain change evolution within the framework of the Divine Infinite Being, blending divine insights with the latest in cognitive development and neural transformation."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=22" />
      </Head>


      <Common_html BlockData={BlockData} />
    
    </>
  );
}
